//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

import processTemplate from 'string-template';
export default {
	name: "BlueQuery",
	components: {},
	data() {
		return {};
	},
	computed: {
		autocomplete() {
			const autocomplete = this.options.queryAllowAutocomplete;
			return autocomplete === true ?
				'on' : 
				autocomplete === false ? 
					'off' : 
					typeof autocomplete === 'string' && autocomplete.trim().length ?
						autocomplete.trim() :
						false;
		},
		currentResultsStart() {
			let totalResults = this.results.totalResultCount;
			if (this.results.currentPage == 0 || this.options.preserveResults) {
				if (totalResults) return 1;
				return 0;
			}
			return this.results.currentPage * this.results.pageSize + 1;
		},
		currentResultsEnd() {
			let totalResults = this.results.totalResultCount;
			let currentPage = this.results.currentPage;
			let pageSize = this.results.pageSize;
			let max = (currentPage + 1) * pageSize;

			if (currentPage == 0) {
				if (totalResults <= pageSize) {
					return totalResults;
				}
				return pageSize;
			} else {
				if (max > totalResults) return totalResults;
				return max;
			}
		},
		label() {
			return processTemplate(this.options.resultsLabelTemplate, {
				start: this.currentResultsStart,
				end: this.currentResultsEnd,
				total: this.results.totalResultCount,
			});
		},
		results() {
			return this.$store.getters.results;
		},
		sort() {
			return this.$store.getters.sort;
		},
		sortModel: {
			get() {
				return this.sort;
			},
			set(val) {
				this.setSort(val);
			},
		},
		query() {
			return this.$store.getters.query;
		},
		queryModel: {
			get() {
				return this.query;
			},
			set(val) {
				this.setQuery(val);
			},
		},
		extended() {
			return this.$store.getters.extended;
		},
	},
	methods: {
		clearPreviousItemResults() {
			this.$store.commit("clearPreviousItemResults");
			this.$store.commit("setPageIndex", 0);
		},
		setSort(val) {
			let value;
			if (typeof val === "object" && val.hasOwnProperty("target"))
				value = val.target.value;
			else value = val;
			this.$store.dispatch("changeSort", value);
		},
		setQuery(val) {
			let value;
			if (typeof val === "object") value = val.target.value;
			else value = val;
			this.$store.commit("setQuery", value);
		},
		resetSearch(callback) {
			this.$store.dispatch("resetSearch", callback);
		},
		extend(callback) {
			this.$store.commit("extend", callback);
		},
		executeSearch(callback) {
			if (this.options.preserveResults) this.$store.commit("clearPreviousItemResults");
			return this.$store.dispatch("executeSearch", callback);
		},
	},
	created() { },
	mounted() { },
};
